export default "__VITE_ASSET__CPgAa9cr__"